//------------------------------|| LOGIN ||---------------------------------------
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_ERROR_CLEAR = 'LOGIN_ERROR_CLEAR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';

//------------------------------|| PROFILE ||-------------------------------------
export const PROFILE_PENDING = 'PROFILE_PENDING';
export const LOGIN_USER_PROFILE = 'LOGIN_USER_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const PROFILE_ERROR_CLEAR = 'PROFILE_ERROR_CLEAR';